import request from './request';

export default {
	getAll(query) {
		return request.get('/payments', query);
	},

	sendPayment(body) {
		return request.post('/payments', body);
	},

	createShopifyAbandonedCartPayment() {
		return request.post('/payments/shopify/abandoned-cart/create');
	},

	activateShopifyAbandonedCartPayment() {
		return request.post('/payments/shopify/abandoned-cart/activate');
	},

	activatePayment(id) {
		return request.post(`/payments/${id}/activate`);
	}
};



// WEBPACK FOOTER //
// ./src/helpers/chated-client/payment.js